import { factory, sequence } from 'stahlwerk';

export const createRoom = factory({
  id: sequence(),
  crewId: sequence(),
  users: [{ id: sequence() }, { id: sequence() }, { id: sequence() }],
});
